/**
 * Age rules for the Talents initiative — mirrors talents/services/age.py.
 *
 * UAE PASS does not issue independent digital identities below 15, so a
 * student under that age registers through a parent or legal guardian. This
 * decides only what the form asks for; the backend enforces the rule.
 */
export const MINOR_AGE_THRESHOLD = 15;

/** Completed years between birthDate (YYYY-MM-DD) and today, or null if unparseable. */
export function ageFrom(birthDate: string): number | null {
  if (!birthDate) return null;
  const born = new Date(birthDate);
  if (Number.isNaN(born.getTime())) return null;
  const today = new Date();
  let years = today.getFullYear() - born.getFullYear();
  const beforeBirthday =
    today.getMonth() < born.getMonth() ||
    (today.getMonth() === born.getMonth() && today.getDate() < born.getDate());
  if (beforeBirthday) years -= 1;
  return years;
}

/**
 * True when a guardian must be supplied for this birth date.
 *
 * An empty or unparseable date returns false so the guardian block does not
 * flash open while the user is still typing; the backend fails closed instead.
 */
export function requiresGuardian(birthDate: string): boolean {
  const age = ageFrom(birthDate);
  if (age === null) return false;
  return age < MINOR_AGE_THRESHOLD;
}
